// this.$store.state.siniestro
import { db } from "@/firebase";
import {
  doc,
  query,
  collection,
  where,
  getDocs,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import moment from "moment";
import { colecciones } from "../constantes";

// SINIESTRO
export const siniestro = {
  objeto: class {
    constructor() {
      return {
        id: "",
        idEmpresa: "",
        idVehiculo: "",
        idInvolucrado: "",
        tipo: "",
        investigacionSancion: "",
        danoConsecuencia: "",
        causaProbable: "",
        usoCinturonEpp: "",
        estadoVehiculo: "",
        velocidadAproximada: 0,
        accionMejora: "",
        observaciones: "",
        ocurrencia: {
          fecha: "",
          hora: "",
        },
        // 2025-08-04 - 5:53 a.m - Nuevas variables PESV
        afectacion: {
          bienes: "",
          personas: "",
          costos: "",
          reputacion: "",
          medioAmbiente: "",
        },
        ubicacion: {
          seleccion: "",
          direccion: "",
          coordenadas: {
            latitud: "",
            longitud: "",
            precision: "",
          },
        },
        condicion: {
          via: "",
          climatica: "",
        },
        parteTransito: {
          seleccion: "",
          archivo: {
            nombre: "",
            tipo: "",
            url: "",
          },
        },
        evidencia: {
          nombre: "",
          tipo: "",
          url: "",
        },
        registro: {
          idUsuario: "",
          filtro: moment().format("YYYY-MM-DD"),
          creacion: serverTimestamp(),
          actualizacion: serverTimestamp(),
          estado: "Creado",
        },
      };
    }
  },
  funciones: {
    async crear(siniestro) {
      if (siniestro.ubicacion.seleccion === "Dirección") {
        siniestro.ubicacion.coordenadas.latitud = "";
        siniestro.ubicacion.coordenadas.longitud = "";
        siniestro.ubicacion.coordenadas.precision = "";
      }
      if (siniestro.ubicacion.seleccion === "Coordenadas") {
        siniestro.ubicacion.direccion = "";
      }
      if (siniestro.parteTransito.seleccion === "No") {
        siniestro.parteTransito.archivo.url = "";
        siniestro.parteTransito.archivo.nombre = "";
        siniestro.parteTransito.archivo.tipo = "";
      }
      siniestro.registro.creacion = serverTimestamp();
      siniestro.registro.actualizacion = serverTimestamp();
      await setDoc(
        doc(
          db,
          colecciones.firebase.seguridadVial.vehiculos.siniestros.registros,
          siniestro.id,
        ),
        siniestro,
      );
    },
    async actualizar(siniestro) {
      if (siniestro.ubicacion.seleccion === "Dirección") {
        siniestro.ubicacion.coordenadas.latitud = "";
        siniestro.ubicacion.coordenadas.longitud = "";
        siniestro.ubicacion.coordenadas.precision = "";
      }
      if (siniestro.ubicacion.seleccion === "Coordenadas") {
        siniestro.ubicacion.direccion = "";
      }
      if (siniestro.parteTransito.seleccion === "No") {
        siniestro.parteTransito.archivo.url = "";
        siniestro.parteTransito.archivo.nombre = "";
        siniestro.parteTransito.archivo.tipo = "";
      }
      await updateDoc(
        doc(
          db,
          colecciones.firebase.seguridadVial.vehiculos.siniestros.registros,
          siniestro.id,
        ),
        {
          idVehiculo: siniestro.idVehiculo,
          idInvolucrado: siniestro.idInvolucrado,
          tipo: siniestro.tipo,
          investigacionSancion: siniestro.investigacionSancion,
          danoConsecuencia: siniestro.danoConsecuencia,
          causaProbable: siniestro.causaProbable,
          usoCinturonEpp: siniestro.usoCinturonEpp,
          estadoVehiculo: siniestro.estadoVehiculo,
          velocidadAproximada: siniestro.velocidadAproximada,
          accionMejora: siniestro.accionMejora,
          observaciones: siniestro.observaciones,
          ocurrencia: siniestro.ocurrencia,
          afectacion: siniestro.afectacion,
          ubicacion: siniestro.ubicacion,
          condicion: siniestro.condicion,
          parteTransito: siniestro.parteTransito,
          evidencia: siniestro.evidencia,
          "registro.estado": "Editado",
          "registro.filtro": siniestro.registro.filtro,
          "registro.actualizacion": serverTimestamp(),
        },
      );
    },
    async eliminar(id) {
      await updateDoc(
        doc(
          db,
          colecciones.firebase.seguridadVial.vehiculos.siniestros.registros,
          id,
        ),
        {
          "registro.estado": "Eliminado",
          "registro.actualizacion": serverTimestamp(),
        },
      );
    },
    async obtener(id) {
      const q = query(
        collection(
          db,
          colecciones.firebase.seguridadVial.vehiculos.siniestros.registros,
        ),
        where("id", "==", id),
        where("registro.estado", "in", ["Creado", "Editado"]),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.length > 0
        ? querySnapshot.docs[0].data()
        : null;
    },
    async generarID() {
      const refSiniestro = doc(
        collection(
          db,
          colecciones.firebase.seguridadVial.vehiculos.siniestros.registros,
        ),
      );
      return refSiniestro.id;
    },
  },
};
